import { useViewContext } from "@editor-providers";
import { useMediaLazyLoad } from "@/shared";
import { ComboBackgroundStyled } from "../styles/Background.styled";
import type { ComboSettingsType } from "../types";
import { BackgroundNode } from "./BackgroundNode";

export const Background = ({ settings }: { settings: ComboSettingsType }) => {
  const { backgroundType, backgroundImage, backgroundVideo } = settings;
  const { view } = useViewContext();
  const isPdf = view === "pdf";
  const displayMedia = shouldDisplayBgMedia(isPdf, settings);
  const isImage = backgroundType?.toLowerCase() === "image" && backgroundImage;
  const isVideo = backgroundType?.toLowerCase() === "video" && backgroundVideo;
  const isBackground = isImage || isVideo;
  const { setObserverRef, isVisible } = useMediaLazyLoad();

  return (
    <ComboBackgroundStyled
      {...STYLED_ATTRIBUTES({ settings })}
      ref={setObserverRef}
      className="comboBackground tw-absolute tw-inset-0 tw-z-0 tw-h-full tw-w-full after:tw-absolute after:tw-inset-0 after:tw-z-2 after:tw-h-full after:tw-w-full after:tw-content-['']"
    >
      {isBackground && displayMedia && (
        <BackgroundNode
          isVisible={isVisible}
          type={isImage ? "image" : "video"}
          url={isImage ? backgroundImage : backgroundVideo}
          pdf={isPdf}
        />
      )}
    </ComboBackgroundStyled>
  );
};

//  ======= ATTRIBUTE CREATION =======
const STYLED_ATTRIBUTES = ({ settings }: { settings: ComboSettingsType }) => {
  const { backgroundColor, overlayOpacity } = settings;
  return {
    $backgroundColor: backgroundColor,
    $overlayOpacity: overlayOpacity,
  };
};
//  ======= ATTRIBUTE CREATION =======

//  ======= HELPERS =======
const shouldDisplayBgMedia = (pdf: boolean, settings: ComboSettingsType) => {
  const { backgroundColor, overlayOpacity } = settings;
  let displayMedia = true;
  if (!pdf) return displayMedia;
  if (
    !["none", "transparent"].includes(backgroundColor) &&
    overlayOpacity === "100"
  ) {
    displayMedia = false;
  }
  return displayMedia;
};

//  ======= HELPERS =======
